import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <section css="padding: 3rem 0;">
            <div className="top-content-wrap" style={{ width: 'auto' }}>
                <div className="top-content">
                    <h1>I&apos;m sorry Ms. Jackson</h1>
                </div>
            </div>

            <div className="content-content-wrap">
                <div className="content-content">
                    <div
                        className="content-content-col"
                        style={{ width: 'auto' }}
                    >
                        <h1 style={{ fontWeight: 700 }}>Got a 404</h1>
                        <h2>Never meant to make your server cry.</h2>
                        <Link to="/industries">
                            Go back to your Dashboard &gt;
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default NotFound;
